import { useTranslation } from 'react-i18next';
import { useInfluencerYoutubeComparePostsQuery } from '@anytag/graphql';
import { useParamsSearch } from '@anytag/shared-hooks';
import { getValuableVariables } from '@anytag/shared-utils';
import { HAS_NO_SELECTED_ACCOUNTS } from '@anytag/shared-constants';
import {
  AnalyticsPostsOverview,
  InfluencerCompareYoutubeAccountsProps,
  InfluencerProfileCompareSearchSchemaType
} from '@anytag/shared-organisms';
import { InfluencerYoutubeComparableAccountType } from '../types';
import { Template } from './Template';

export interface InfluencerCompareYoutubePostsProps
  extends Pick<InfluencerCompareYoutubeAccountsProps, 'accounts' | 'hiddenAccountIds'> {
  mainAccount: InfluencerYoutubeComparableAccountType;
}

export const InfluencerCompareYoutubePosts = ({
  accounts,
  mainAccount,
  hiddenAccountIds
}: InfluencerCompareYoutubePostsProps) => {
  const { t } = useTranslation();
  const { filter } = useParamsSearch<InfluencerProfileCompareSearchSchemaType>();
  const { data, loading } = useInfluencerYoutubeComparePostsQuery({
    variables: getValuableVariables({
      endDate: filter.endDate,
      startDate: filter.startDate,
      socialAccountId: mainAccount.id
    })
  });

  const postsData = data?.influencerYoutubeComparePosts;
  const comparableAccounts = accounts.filter((account) => !hiddenAccountIds?.includes(account.id));

  return (
    <AnalyticsPostsOverview
      data={postsData}
      loading={loading}
      help={t('Tooltip.comparePosts')}
      dataNotAvailable={!comparableAccounts.length || !postsData}
      wrapperText={!comparableAccounts.length ? HAS_NO_SELECTED_ACCOUNTS : undefined}
      moreDetailProps={{
        to: '/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos',
        params: { socialMediaAccountId: mainAccount.id.toString() },
        search: {
          filter: {
            endDate: filter.endDate,
            startDate: filter.startDate,
            name: mainAccount.username
          }
        }
      }}
    >
      {({ data }) => <Template data={data} comparableAccounts={comparableAccounts} />}
    </AnalyticsPostsOverview>
  );
};
